import React from 'react';
import { motion } from "framer-motion";
import Tags from './Tags';
import ImageOptimized from './ImageOptimized';
import './ProjectThumb.css';

const ProjectThumb = ({ project, onClick }) => {
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            onClick();
        }
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: [0, 1, 1, 1], y: [100, 0] }}
            viewport={{ once: true }}
            transition={{y: { duration: 0.8, ease: 'easeOut'}, opacity: { duration: 0.6, ease: 'easeIn', delay: 0.1 }}}
            className="project-thumb"
            tabIndex="0"
            onKeyDown={handleKeyDown}
        >
            <div
                className="project-thumb__image"
                onClick={onClick}
            >
                <ImageOptimized src={project.thumbSrc} alt={project.title} />
            </div>
            <div className="project-thumb__text">
                {project.tags && (
                    <Tags project={project} />
                )}
                <h3>{project.title}</h3>
            </div>
        </motion.div>
    );
};

export default ProjectThumb;